import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-notice',
  templateUrl: 'privacy-policy.component.html',
})
export class PrivacyPolicyComponent {}
